import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import FooterElement from "../../Components/footer/FooterElement";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Skeleton,
  TextField,
  Stack,
  MenuItem,
  IconButton,
  Typography,
  Modal,
  Switch,
  InputAdornment,
} from "@mui/material";
// import SearchBar from "../../Components/SearchBar/SearchBar";
// import "./ItemMaster.css";
import EyeIcon from "@mui/icons-material/RemoveRedEye";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { purple } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { useEffect } from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import { createFilterOptions } from "@mui/material/Autocomplete";
import PrintIcon from "@mui/icons-material/Print";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
toast.configure();

const HsnMissMatch = () => {
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };
  const [disDown, setDisDown] = useState(true);
  const [rows, setrows] = useState([]);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      field: "itemcode",
      headerClassName: "super-app-theme--header",
      headerName: "Partno",
      width: 250,
    },
    {
      field: "itemname",
      headerClassName: "super-app-theme--header",
      headerName: "Part Desc",
      width: 350,
    },
    {
      field: "closingqty",
      headerClassName: "super-app-theme--header",
      headerName: "Current Stock",
      width: 150,
    },
    {
      field: "hsncode",
      headerClassName: "super-app-theme--header",
      headerName: "HSN",
      width: 300,
    },
    {
      field: "item_gstrate",
      headerClassName: "super-app-theme--header",
      headerName: "Gst% In Item Master",
      width: 300,
    },
    {
      field: "hsn_gstrates",
      headerClassName: "super-app-theme--header",
      headerName: "Gst% In HSN Master",
      width: 300,
    },
  ];

  //stock auto correct
  const fetchHsnData = async (e) => {
    try {
      const res = await fetch("/stock/mismatch/hsn", {
        method: "GET",
        headers: {
          sptoken: userToken,
        },
      });
      const data = await res.json();
      if (data.type === "success") {
        toast.info(data.message);
        setrows(data.data);
        setDisDown(false);
      } else {
        toast.info(data.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  //print excel
  const printexcel = async (e) => {
    e.preventDefault();
    try {
      const data = await fetch("/stock/mismatch/hsn/excel", {
        method: "GET",
        headers: {
          sptoken: userToken,
        },
      });

      const blob = await data.blob();

      // Generate current date in YYYY-MM-DD format
      const today = new Date();
      const day = today.getDate().toString().padStart(2, "0");
      const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-based
      const year = today.getFullYear();
      const formattedDate = `${day}${month}${year}`;
      let hours = today.getHours();
      const minutes = today.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM

      const time = `${hours}-${minutes} ${ampm}`;
      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = `Mismatched_HSN_${formattedDate}_${time}.xlsx`; // Add extension if needed

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div>
      <Sidebar
        Title={"MISMATCH HSN"}
        expandedPanel={"panel1"}
        children={
          <Box
            component="form"
            //onSubmit={handleSubmit}
            sx={{
              width: "100%",
            }}
          >
            <Button onClick={fetchHsnData} color="primary" variant="contained">
              Fetch MisMatch HSN Data
            </Button>
            <Button
              disabled={disDown}
              onClick={printexcel}
              sx={{ ml: 5 }}
              color="success"
              variant="contained"
            >
              Download Excel
            </Button>
            <Box
              sx={{
                height: 550,
                width: "100%",
                position: "relative",
                mt: "20px",
                boxShadow: "2px 6px 15px #5a5a5a",
                // border: "0.5px solid black",
                // borderRadius: "5px",
                "& .super-app-theme--header": {
                  backgroundColor: "#3bb9ff",
                  color: "#000",
                },
                "& .custom-font-size": {
                  fontSize: 13, // Adjust the font size as needed
                },
              }}
            >
              <DataGrid
                sx={{
                  border: "1px solid #000",
                  "& .MuiDataGrid-cell:focus": {
                    outline: "2px solid red", // Change this to the desired color
                    backgroundColor: "gray",
                    color: "white",
                  },
                }}
                rowHeight={35}
                headerHeight={30}
                showColumnRightBorder={true}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.itemid}
                loading={loading}
                components={{
                  LoadingOverlay: () => (
                    <div style={{ padding: 20, textAlign: "center" }}>
                      🔄 Loading data...
                    </div>
                  ),
                }}
              />
            </Box>
          </Box>
        }
      />
      {/* <FooterElement /> */}
      {redirectToLoginPage()}
    </div>
  );
};

export default HsnMissMatch;
